module.exports = __webpack_public_path__ + "static/media/take-challenge-popup-male-image.82d9c1c5.png";